import { ACTIONS } from '../../_config'
import { ActionExtended } from '../../_config/interfaces'
import { APP_LANGUAGE_STORAGE_KEY, getInitialLanguage, normalizeLanguage } from '../../i18n'

export interface LoaderReducer {
    fpLoader: boolean
    lang: string
}

const initialState: LoaderReducer = {
    fpLoader: false,
    lang: getInitialLanguage(),
}

const loaderReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.LOADER.FP_STATUS:
            return {
                ...state,
                fpLoader: action.payload,
            }
        case ACTIONS.LOADER.LANG: {
            // Keep redux + localStorage language values constrained to supported languages only.
            const nextLanguage = normalizeLanguage(typeof action.payload === 'string' ? action.payload : null)
            if (typeof globalThis !== 'undefined') {
                localStorage.setItem(APP_LANGUAGE_STORAGE_KEY, nextLanguage)
            }
            return {
                ...state,
                lang: nextLanguage,
            }
        }
        default:
            return state
    }
}

export default loaderReducer
